import React, { useEffect, useState, useMemo } from 'react';
import './styles.scss';
import {
  Flex,
  Grid,
  Image,
  Text,
  Popover,
  Box,
  TypographyStylesProvider,
  ScrollArea
} from '@mantine/core';
import { getSharepointCdnFile } from '../../../utilities';
import Button from '../../elements/Button';
import { ContentSectionDetail } from '.';
import NoImage from '../../../assets/icon/illustrations_no-document.svg';
import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import { dateFormat } from '../../../utilities/dataFormat';
import { useHistory } from 'react-router-dom';
import { highlightText } from '../../../utilities/highlightText';

const ContentItem: React.FC<ContentSectionDetail> = ({
  contentId,
  imageFilePath,
  permalink,
  shortDescription,
  title,
  isCarousel,
  dateIn,
  isPreview,
  breakpoint,
  style,
  querysearch
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  const router = useHistory();
  const [spanSize, setSpanSize] = useState<any>({
    base: 12,
    sm: 6,
    lg: 3,
    xl: 4
  });
  const publishSize = { base: 12, sm: 6, lg: 3 };
  const previewMobileSize = { base: 12 };
  const previewDesktopSize = { base: 12, sm: 6, lg: 4, xl: 3 };
  const previewModalSize = { base: 12, sm: 6, lg: 3 };

  useEffect(() => {
    if (isPreview) {
      if (breakpoint === 'mobile') {
        setSpanSize(previewMobileSize);
      } else if (breakpoint === 'desktop') {
        setSpanSize(previewDesktopSize);
      } else {
        setSpanSize(previewModalSize);
      }
    } else {
      setSpanSize(publishSize);
    }
  }, [isPreview, breakpoint]);

  const renderItem = useMemo(() => {
    return (
      <Popover
        width={300}
        position="right"
        withArrow
        shadow="xl"
        radius={12}
        arrowSize={16}
        arrowOffset={0}
        opened={opened}
      >
        <Popover.Target>
          <div
            className={
              'container_content_item' +
              ` ${isCarousel === 'Y' ? 'carousel' : ''}`
            }
            style={{ ...style }}
            onMouseEnter={() => open()}
            onMouseLeave={() => close()}
          >
            <div className="container_content_item__content">
              <div
                className="container_content_item__content-wrapper-cover"
                style={{
                  backgroundColor: '#F5F5F5'
                }}
              >
                {/* image with contain */}
                <Image
                  className={`${
                    imageFilePath
                      ? 'container_content_item__content-contain'
                      : 'container_content_item__content-cover'
                  }`}
                  src={
                    imageFilePath
                      ? getSharepointCdnFile(imageFilePath)
                      : NoImage
                  }
                  alt={title}
                ></Image>
              </div>

              <Flex direction={'column'} mt={12}>
                <Text
                  className="container_content_item__content-title"
                  fz={12}
                  fw={700}
                >
                  {querysearch ? highlightText(title, querysearch) : title}
                </Text>
                <Text fz={12} c={'gray'} fw={600}>
                  {dateIn ? dayjs(dateIn).format(dateFormat('datetime')) : ''}
                </Text>
              </Flex>
            </div>

            <Button variant="link" linkTo={`/page/${permalink || contentId}`}>
              Read More
            </Button>
          </div>
        </Popover.Target>

        <Popover.Dropdown
          onMouseEnter={() => open()}
          onMouseLeave={() => close()}
        >
          <Box component="div" h={300}>
            <ScrollArea h={250} mb={4}>
              <Flex direction={'column'} my={16}>
                <Text fz={16} fw={700}>
                  {highlightText(title, querysearch)}
                </Text>
                {/* <Text fz={12} c={'gray'} fw={600}>
                  {dayjs(dateIn)
                    .locale(localeId)
                    .format(dateFormat('datetime'))}
                </Text> */}
              </Flex>
              <TypographyStylesProvider p={0} m={0}>
                <div dangerouslySetInnerHTML={{ __html: shortDescription }} />
              </TypographyStylesProvider>
              <div className="container_content_item__content-wrapper-cover">
                <Image
                  className="container_content_item__content-cover"
                  src={
                    imageFilePath
                      ? getSharepointCdnFile(imageFilePath)
                      : NoImage
                  }
                  alt={title}
                />
              </div>
            </ScrollArea>
            <Button
              onClick={() => {
                router.push(`/page/${permalink || contentId}`);
              }}
              full
              variant="transparent"
            >
              Read More
            </Button>
          </Box>
        </Popover.Dropdown>
      </Popover>
    );
  }, [
    opened,
    imageFilePath,
    title,
    dateIn,
    permalink,
    contentId,
    shortDescription
  ]);

  if (isCarousel === 'Y') {
    return <>{renderItem}</>;
  }

  return <Grid.Col span={spanSize}>{renderItem}</Grid.Col>;
};

export default ContentItem;
